import { MapPin, Phone, Mail } from "lucide-react";
export default function Contact() {
  return (
    <div className="flex flex-col gap-4">
      <div className="bg-white border border-border rounded-2xl px-11 py-10 max-[680px]:px-6 max-[680px]:py-7">
        <h1 className="font-display text-[30px] font-semibold text-primary-dark mb-2.5 leading-tight">Contact &amp; Order Form</h1>
        <p className="text-sm text-[#555] leading-relaxed max-w-[620px]">
          Reach out to learn more about the MA &amp; PA Program, order materials, or find out how to become a certified Consultant-Trainer.
        </p>
      </div>

      <div className="grid gap-3 max-[680px]:grid-cols-1">
        {/* Contact info */}
        <div className="bg-white border border-border rounded-2xl p-8 flex flex-col gap-4">
          <h2 className="font-display text-xl font-semibold text-primary-dark">Contact Information</h2>

          <div className="flex items-start gap-2.5 text-[13px] text-[#555] leading-snug">
            <div className="w-7 h-7 rounded-lg bg-primary-light flex items-center justify-center shrink-0">
              <MapPin className="w-4 h-4 accent-purple-700" />
            </div>
            <div>
              <strong>Center for Growth &amp; Development, Inc.</strong><br />
              2015 S. Tuttle Ave #D<br />
              Sarasota, FL 34239
            </div>
          </div>

          <div className="flex items-start gap-2.5 text-[13px] text-[#555] leading-snug">
            <div className="w-7 h-7 rounded-lg bg-primary-light flex items-center justify-center shrink-0">
              <Phone className="w-4 h-4 accent-purple-700" />
            </div>
            <div>
              Toll-free: 1-888-390-1119<br />
              Tel: 941-953-9556<br />
              Fax: 941-953-9552
            </div>
          </div>

          <div className="flex items-start gap-2.5 text-[13px] leading-snug">
            <div className="w-7 h-7 rounded-lg bg-primary-light flex items-center justify-center shrink-0">
              <Mail className="w-4 h-4 accent-purple-700" />
            </div>
            <a href="mailto:info@nurturingfathers.com" className="text-primary no-underline hover:underline">
              info@nurturingfathers.com
            </a>
          </div>

          <p className="text-xs text-[#888] leading-relaxed">
            For questions about the MA &amp; PA Program, orders, or Consultant-Trainer workshops, please email or call during business hours Monday–Friday, 9am–5pm EST.
          </p>

          <div className="bg-gradient-to-br from-primary to-primary-dark rounded-xl p-4 mt-1">
            <h4 className="font-display text-[15px] text-white mb-1">Related Program</h4>
            <p className="text-[13px] text-white/75 leading-snug">
              The MA &amp; PA Program is a companion to the <strong className="text-white">Nurturing Fathers Program</strong>. Visit nurturingfathers.com to learn more.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
